import _ from 'lodash';
import moment from 'moment';

export const saveToCSV = (model, rows, filename, titles, processList) => {
  const colTitles = titles || _.map(model, (col) => col.key);
  const table = _.map(rows, (row) => {
    const rowTable = _.map(model, (field) => {
      const { type, key } = field;
      const value = _.get(row, key, '');
      switch (type) {
        case 'string':
          return `"${_.replace(value, /"/g, '""')}"`;
        case 'number':
          return Number(value);
        case 'list':
          return `${processList(row, key)}`;
        default:
          return value;
      }
    });
    return rowTable.join();
  });

  table.unshift(colTitles.join(','));

  const csvFile = table.join('\n');
  const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`); // .csv ext is needed for windows
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatTimestamp = (data, timestampColumn) => {
  return _.map(data, (row) => {
    return {
      ...row,
      [timestampColumn]: moment(row[timestampColumn]).format(
        'MM/DD/YY h:mm:ssa'
      ),
    };
  });
};

export const formatCsvData = (file) => {
  const csvFormData = new FormData();
  csvFormData.append('file', file);
  return csvFormData;
};

export const formatSkus = (skus) =>
  skus
    .replace(/\s*,\s*/g, ',')
    .split(',')
    .filter((sku) => sku);

export const countProducts = async (products) => {
  if (typeof products === 'string') return formatSkus(products).length;
  const fileText = await products.text();
  const count = fileText.split('\n').length - 1;
  return count;
};

export const CSV_MODAL_TYPES = {
  editCampaign: 'editCampaign',
  addProducts: 'addProducts',
  editProducts: 'editProducts',
  updateVariantDescriptors: 'updateVariantDescriptors',
  editDiscounts: 'editDiscounts',
  addCarts: 'addCarts',
  removeCarts: 'removeCarts',
  addToCampaign: 'addToCampaign',
  addCartsRefills: 'addCartsRefills',
  removeCartsRefills: 'removeCartsRefills',
};

export const formatError = (selectedFile, e) => {
  let msg = 'Upload Failed for unknown reason.';
  const err =
    typeof e === 'string' && e.includes('{') && e.includes('}')
      ? JSON.parse(e)
      : e;
  if (typeof err === 'object') return err;
  // error is a string
  if (selectedFile.size > 16000000) {
    msg = 'Maximum supported file size is 16MB.';
  } else if (err.includes('504')) {
    //display this error if request times out
    msg = 'Please refresh the table to check if your update was successful.';
  } else if (err) {
    msg = err;
  }
  return { value: [msg] };
};

export const sizes = [
  'Bytes',
  'KiB',
  'MiB',
  'GiB',
  'TiB',
  'PiB',
  'EiB',
  'ZiB',
  'YiB',
];

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
